/// <reference types="@types/google.maps" />
import { Component, Inject, ViewChild, ElementRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { DialogBase, T4Image, ImageType, User, ComponentBase, PageBase, T4RentalLocationService, T4SettingsService } from 't4core';
import { Router } from '@angular/router';
import { FindUserDialog } from '../../dialogs/FindUserDialog/FindUserDialog';
import { ChangePasswordDialog } from '../../../../turbo/dialogs/changePassword/changePassword';
import { MatDialog } from '@angular/material/dialog';



@Component({
  selector: 't4-trailerpoint',
  templateUrl: './TrailerPointComponent.html',
  styleUrls: ['./TrailerPointComponent.css']
})

export class TrailerPointComponent extends ComponentBase implements OnInit {

  constructor(el: ElementRef, private router: Router, private dialog: MatDialog, private t4Settings: T4SettingsService) {
    super();
  }

  // Map
  @ViewChild('gmap', { static: true }) gmapElement: any;
  @ViewChild('txtMapSearch', { static: false }) gmapSearchBox: ElementRef;

  private map: google.maps.Map;
  private searchBox: google.maps.places.Autocomplete;
  public markers = [];
  public marker; circle;
  public address: any;
  public latLng; latlong: google.maps.LatLng;
  private infoWindow = new google.maps.InfoWindow();
  public gridsize: number = 25;
  public TrailerInfo = [];
  private autocompleteInitialized = false;



  ngOnInit() {

    var mapProp = {
      center: new google.maps.LatLng(60.5793, 14.8143),
      zoom: 6,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: '2bfb441deccab4d5b8508848',
    };

    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    this.getLocationInfo();

    this.map.addListener("click", (e) => {
      this.addMarker(e.latLng);
      this.getAddress(e.latLng);
      this.updateLocationInfo(e.latLng,this.gridsize);
    });
  }

  public onSearchFocus() {
    if (this.autocompleteInitialized) return;
    this.autocompleteInitialized = true;
    this.initPlacesAutocomplete();
  }

  private initPlacesAutocomplete() {
    if (!this.gmapSearchBox?.nativeElement) return;
    this.searchBox = new google.maps.places.Autocomplete(this.gmapSearchBox.nativeElement, {
      componentRestrictions: { country: ['NO', 'SE', 'DK', 'DE', 'IS'] }, types: ['geocode'], fields: ['geometry']
    });

    this.searchBox.addListener("place_changed", () => {
      let place: google.maps.places.PlaceResult = this.searchBox.getPlace();
      if (!place.geometry) return;

      this.addMarker(place.geometry.location);
      this.getAddress(place.geometry.location);
      this.updateLocationInfo(place.geometry.location, this.gridsize);
      this.latlong = place.geometry.location;
      this.map.panTo(place.geometry.location);
      this.map.setZoom(16);
    });
  }

  // apply new marker to the map
  public addMarker(position) {
    if (this.marker) {
      this.marker.setMap(null);  // remove previous marker
      this.circle.setMap(null)   //might need to set this to this.cirle.map = null instead cuz of advmarker and the one above
    }
    this.marker = new google.maps.marker.AdvancedMarkerElement({

      position: position,
      gmpDraggable: true,
      map: this.map,
      title: "Trailer Point"
    })

    var circlee = new google.maps.Circle({
      strokeColor: "#ADD8E6",
      strokeOpacity:0.8,
      fillColor: "#32CD32",
      strokeWeight: 20,
      map: this.map,
      fillOpacity: 0.35,
      radius: this.gridsize,
      center: this.marker.position
    })


    this.circle = circlee;


    this.marker.addListener('position_changed', () => {
      circlee.setCenter(this.marker.position);
    });

    this.marker.addListener('dragend', (e) => {
      const latLng = e.latLng;
      const newLatLng = new google.maps.LatLng(latLng.lat(), latLng.lng());
      this.circle.setCenter(latLng);
      this.getAddress(newLatLng);
      this.updateLocationInfo(newLatLng, this.gridsize);
      this.latlong = newLatLng;
    });


    this.markers.push(this.marker);

}

  // get real address from latitude and longtitude for the marker
  public getAddress(latlongVal) {

    var latlong = new google.maps.LatLng(latlongVal.toJSON().lat, latlongVal.toJSON().lng);
    var geocoder = geocoder = new google.maps.Geocoder();

    geocoder.geocode({'latLng': latlong }, (results, status) => {

      if (status = google.maps.GeocoderStatus.OK) {

        if (results[1]) {
          this.address = results[1].formatted_address;
          this.infoWindow.setContent(this.address);
          this.infoWindow.open(this.map, this.marker);

        }
        else {
          alert("No results found");
        }
      }
    });
  }

  // slider
  public updateSetting(event) {
    this.gridsize = event;
    this.circle.setRadius(this.gridsize);
    this.updateLocationInfo(this.latLng, this.gridsize);
  }


  // get current location info 
  public async getLocationInfo() {

    var getlocation = await this.t4Settings.GetTrailerPoint();

    this.latLng = new google.maps.LatLng(
      getlocation.TrailerPointLatitude,
      getlocation.TrailerPointLongitude
    );
    this.gridsize = getlocation.TrailerPointRadius;

    if (this.latLng != null) {
      this.addMarker(this.latLng);
      this.map.panTo(this.latLng);
      this.map.setZoom(18);
    }

  }

  // UPDATE LOCATION INFO
  public async updateLocationInfo(latlong, rad) {
    var updatelat = latlong.toJSON().lat;
    var updatelong = latlong.toJSON().lng;
    this.TrailerInfo = await this.t4Settings.UpdateTrailerPoint(rad, updatelat, updatelong);

    return this.TrailerInfo;
  }
}
